module.exports = __webpack_public_path__ + "static/img/icon-floor-item-2.b0ce6711.png";